import { IRouteChildren, RouteKeys } from "@/api_framework/api_modals/Routers";
import { useArrayConstants } from "@/app/hooks/useArrayConstants";
import { VMS_CLICK_EVENTS, VMS_SCREEN_IDS, useVMSClickLog } from "@/app/hooks/useVMSClickLog";
import { Disclosure } from "@headlessui/react";
import clsx from "clsx";
import { startCase } from "lodash";
import { Link, useLocation } from "react-router-dom";
import RBACFlag from "../../RBACFlag";
import { IStaticSidebarSubNavigationOptionProps } from "../../interface";

const SubNavOptionContent: React.FC<{ subNavs: IRouteChildren; child_key: string }> = ({ subNavs, child_key }) => {
  const location = useLocation();
  return (
    <>
      <span
        key={subNavs[child_key].id}
        className={clsx(
          "p-1 w-full  text-sm flex justify-start items-center pl-3 mt-1  rounded-lg",
          location.pathname.includes(subNavs[child_key].url)
            ? "bg-[#F4F8FF] rounded-lg text-[#193A6A] text-xs"
            : "text-gray-200 hover:text-gray-600 hover:bg-gray-100 text-xs hover:scale-105 transition-all",
        )}
      >
        <span className="mr-1 text-[10px] text-[#193A6A]"></span>
        {startCase((subNavs[child_key].title ?? "").split("_").join(" ")).replace(/\b([A-Za-z])\s+(\d)\b/g, "$1$2")}
      </span>
      {location.pathname.includes(subNavs[child_key].url) && (
        <span className=" opacity-50 mb-2 absolute right-0 top-0 h-full w-1"></span>
      )}{" "}
    </>
  );
};

const StaticSidebarSubNavOption: React.FC<IStaticSidebarSubNavigationOptionProps> = ({ subNavs }) => {
  const { excludedNavs } = useArrayConstants();
  const { logVMSClick } = useVMSClickLog(VMS_SCREEN_IDS.SIDEBAR);

  return (
    Object.keys(subNavs).length > 0 && (
      <Disclosure.Panel className="px-4 pb-2  flex flex-col text-sm  ">
        {Object.keys(subNavs).map((child_key) => {
          return (
            !excludedNavs.includes(subNavs[child_key].id) &&
            !subNavs[child_key].isVirtual && (
              <RBACFlag actionId={(subNavs[child_key].rbacActionId ?? child_key) as RouteKeys}>
                <Link
                  key={`${subNavs[child_key].url}:sub_link`}
                  to={subNavs[child_key].url}
                  className="w-full relative mt-1"
                  onClick={() =>
                    logVMSClick(
                      VMS_CLICK_EVENTS.SIDEBAR_SUB_MODULE_CLICK,
                      startCase((subNavs[child_key].title ?? "").split("_").join(" ")),
                      { nav_sub_module_id: subNavs[child_key].id },
                    )
                  }
                >
                  <SubNavOptionContent child_key={child_key} subNavs={subNavs} />
                </Link>
              </RBACFlag>
            )
          );
        })}
      </Disclosure.Panel>
    )
  );
};

export default StaticSidebarSubNavOption;
